// Vendor imports
const classNames = require('classnames')
const React = require('react')
const qs = require('qs')
// Shared imports
const BemEntity = require('shared/bem')
const { urlWithoutProtocol } = require('shared/utils')

// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const Icon = require('client-v2/common/containers/icons/component')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('IntoLandingDownloadLinks')

function IntoLandingDownloadLinks(props) {
  const { isAndroid, isDesktop, isIos, deeplinkHref, onClick, openInAppTitle, showSMSModal, trackAppDownload } = props

  const handleDownloadClick = React.useCallback(
    event => {
      const { provider } = event.currentTarget.dataset
      event.preventDefault()
      trackAppDownload(provider)
      const deeplinkData = {
        // Delivered as query parameter when handling the universal links.
        'deeplink_url': location.href,
        // Fallbacks to mix://$deeplink_path when universal links do not work.
        // Docs: https://docs.branch.io/pages/links/integrate/#deep-linking
        '$deeplink_path': urlWithoutProtocol(location.href)
      }
      if (isDesktop) {
        onClick ? onClick() : showSMSModal({
          deeplinkData,
          isDownloadPromptVisible: false
        })
        return
      }

      const queryString = qs.stringify(deeplinkData)
      location.assign(`${deeplinkHref}?${queryString}`)
    },
    [ deeplinkHref, isDesktop, onClick, showSMSModal, trackAppDownload ]
  )
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag(CapsuleButton, {
        className: bem.element('download'),
        'data-provider': isIos ? 'ios' : isAndroid ? 'android' : null,
        href: deeplinkHref,
        onClick: handleDownloadClick
      },
        !isDesktop && tag(Icon, { id: isIos ? 'apple' : 'android' }),
        tag('div', {
          className: bem.element('link-text')
        },
          openInAppTitle
        )
      )
    )
  )
}

module.exports = IntoLandingDownloadLinks
